Ext.ns('mx.plugin');

/*
 * Both grid should define property 'dependency'. Possible values: 'independent' and 'dependent'
 *
 * */
mx.plugin.GridDependent = function(/*Object config*/ config) {
    this.paramName = 'filterId';
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.GridDependent, Ext.util.Observable, {
    init: function(/*Ext.grid.GridPanel*/ grid) {
        if (grid.dependency == 'independent') {
            this.independent = grid;
        } else if (grid.dependency == 'dependent') {
            this.dependent = grid;
        }

        if (this.dependent && this.independent) {
            this.dependent.rel = this.independent;
            this.independent.rel = this.dependent;
            this.independent.selModel.on(
                'rowselect',
                function(sm, rowIndex, event) {
                    var record = this.independent.store.getAt(rowIndex);
                    this.dependent.filterId = record.getRecordId();
                    this.dependent.store.baseParams[this.paramName] = record.get('id');
                    this.dependent.store.load();
                },
                this
            );
            this.independent.selModel.on(
                'rowdeselect',
                function() {
                    this.dependent.el.mask();
                },
                this
            );
        }
    },
});
